/**
 * Created by Jerker Nord on 2024-01-17.
 */
import {
   SimplePresentation,
   SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";

export class LonerShootShootDuckResponsePresentation implements SimplePresentation{

   private _controller: SimplePresentationRunnerController;
   private _shootingComplete:boolean = false;

   public shouldRun(): boolean {
      return (Loner.model.data.mode == LonerGameMode.FEATURE_SHOOT_SHOOT_DUCK);
   }

   public start(controller: SimplePresentationRunnerController): void {
      this._controller = controller;
      this.checkFinish();
   }

   private checkFinish():void{
      if (this._shootingComplete == true){
         this._shootingComplete = false;
         this.complete();
      }
   }

   protected complete(): void {
      this._controller.finish();
   }

   set shootingComplete(value:boolean) {
      this._shootingComplete = value;
      this.checkFinish();
   }
}